// extracted by mini-css-extract-plugin
module.exports = {"form":"register_form__5RtaD","checkboxLabel":"register_checkboxLabel__1AVUY","textField":"register_textField__fIg5U","links":"register_links__2e4om"};